<main>
  <ng-container *ngFor="let project of projects">
    <project-card [project]="project"></project-card>
  </ng-container>
</main>